import React from "react";
import PropTypes from "prop-types";
import IconoConvenio from "./IconoConvenio";
import "./ConvenioCard.css";

/**
 * Tarjeta interactiva de Convenio.
 * Enlace completo <a> con icono en contenedor de 110px y título en mayúsculas.
 * 
 * @param {string} title - Título o nombre del convenio.
 * @param {string} url - Enlace de descarga o visualización del documento PDF.
 * @param {number} [delayMs=0] - Retardo para la animación de entrada escalonada.
 * @param {string} [className] - Clases CSS adicionales.
 */
const ConvenioCard = ({
  title,
  url,
  delayMs = 0,
  className = "",
}) => {
  const animationStyle = delayMs > 0 ? { animationDelay: `${delayMs}ms` } : undefined;
  const uppercaseTitle = title ? title.toUpperCase() : "";

  return (
    <div className="convenio-grid-item" style={animationStyle}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`convenio-card ${className}`.trim()}
        aria-label={`Abrir convenio: ${title}`}
      >
        {/* Contenedor de 110px con esquinas redondeadas y sombra suave */}
        <div className="convenio-icon-wrapper">
          <IconoConvenio />
        </div>

        {/* Nombre en mayúsculas, centrado, máximo 2 líneas */}
        <p className="convenio-title">{uppercaseTitle}</p>
      </a>
    </div>
  );
};

ConvenioCard.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  delayMs: PropTypes.number,
  className: PropTypes.string,
};

export default ConvenioCard;
